import * as actions from "store/actions/nfse/create";
import INFSe from "Types/INFSe";

export interface NFSeCreateState extends INFSe {
	loading: boolean;
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: NFSeCreateState = {
	loading: false,
	value: "",
	code: "",
	errors: {}
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.CREATE_NFSE: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.CREATE_NFSE_SUCCESS: {
			return {
				...initialState
			};
		}
		case actions.CREATE_NFSE_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
